$(document).ready(function() {

	// $(".main_nav_wrapper:not(.sticky_nav) .cart_container").addClass("active_link");

	if ($(window).width() > 767) resizeHPSlider();

	if (typeof checkFreeShippingMsg == 'function') 
		checkFreeShippingMsg();
  
  
  if ($(window).width() > 767) {
    setTimeout(function () {
      
      $(".slider-gallery").each(function () {
        $(this).find(".flickity-prev-next-button").insertAfter($(this));
      });
      
    },1000);
  }


  $("footer .shop-list > div").click(function () {
  	$(this).find("ul").toggleClass("open");
  });
  
  /*$("footer .shop-list > div a").click(function (e) {
  	if (!$(this).parent().parent().hasClass("open"))
  		e.preventDefault();
  });*/

});

$(window).resize(function(event) {
	if ($(window).width() > 767) resizeHPSlider();
});

function resizeHPSlider () {

	if ($(window).width() < 1150) {
		$(".homepage-slideshow").height($(".homepage-slideshow .gallery-cell.slide-1 img").height())
	} else {
		$(".homepage-slideshow").height($(window).height()*.7)
	}
	
}

function closeCart () {
	$('body').removeClass('is-active');
        $('.dropdown_link').toggleClass('active_link');
        $('.cart_container').removeClass('active_link');
        $("body").removeClass("stop-scroll");
}

function addAsterisk(_f) {
	//console.log(_f)
	//console.log($(_f))
	var input = $(_f).find("input[type='text']")
    var qvalue = input.val();
    var qvalueStr = qvalue.split(" ");
      var newqvalue = "";
      for(var i =0; i < qvalueStr.length; i++){
    newqvalue += qvalueStr[i] + "* ";   
    }
    input.val(newqvalue);  
}

function styleTitle (str) {
	//used in app.js line 2687
	var t = str.split(" | ");
	return '<strong>'+t[0]+'</strong><br><span class="sub_title">'+t[1]+'</span>';
}


function getDesignerProducts (tag) {
	
	$.ajax({
	    url: "/search", 
	    data: {
	       q: "tag:des="+tag, 
	       type: "product",
	       view: "bytag"
	    },
	    dataType: "text",
	    success: function( data ) {
	      // do something
	      console.log(data);
	      $(".designer-products-grid").html(data)
	    }
	  });
}





//Popup
var geoPopup = $('.geoip-main-block');

geoPopup.ready(function(){
	setTimeout(function () {

    var yesButton = $('button.geoip-yes-btn');
		var noButton = $('button.geoip-no-btn');

		yesButton.text('Yes, take me to the US Store');
		noButton.text('No, I want to stay in the International Store');

  },500);
});




//PDP More Details
var accordionContent = $('.accordion-content');
if( accordionContent.length ) {
	var accordionTrigger = $(".accordion-trigger");
	var socials = $('.details-holder .special-details .social_buttons');
	var icons = $('.details-holder .special-details .icons');
	socials.css("border-top", "0");
	icons.css("padding-bottom", "18px");


	accordionContent.hide(), accordionTrigger.click(function(t) {
      t.preventDefault(); 

      if (accordionContent.hasClass("close")) {
     		accordionContent.slideDown();
      } else {
      	 accordionContent.slideUp();
      }
      accordionContent.toggleClass("close");
      accordionTrigger.toggleClass("close");
  });
}


//PDP Quantity Box
var quantityWrap = $('.details-holder .quantity-wrap');
var addToCart =  $('.details-holder .action_button.add_to_cart');
quantityWrap.append(addToCart);


//PDP Show Ratings
$("body").on('DOMSubtreeModified', ".details-holder", function() {
  var rating = $('.spr-badge');
	if( rating.length ) {
		var ratingAmount = rating.attr('data-rating');
		//Hide Rating if it's less than 4
		if (ratingAmount <= 3.9) {
			rating.addClass('hidden');
		}
	}	
});




